// extracted by mini-css-extract-plugin
export default {"heading":"Skills_heading__xaEOY","maincont":"Skills_maincont__Y-46E","cont":"Skills_cont__U07aT","img":"Skills_img__hlLdZ","text":"Skills_text__Lh9q3"};